import React, { Component } from 'react';
import { DraggableWindow } from '../DraggableWindow';
import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import './ReadilyAvailableHouseTool.css'
import { ReadilyAvailableHouseItem } from './ReadilyAvailableHouseItem/ReadilyAvailableHouseItem';

import ok from './.image/ok.png';
import error from './.image/error.png';
import loading from './.image/loading.gif';

export class ReadilyAvailableHouseTool extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            fileName: "",
            uploadDataArray: new Array(3),
            checkStates: [],
            errorMessage: "",
            tabIndex: 0,
            errorCols: [],
            errorRows: [],
            downloadExcel: "",
            loading:false,
        }

        this.list = [
            {
                name: "輸入"
            },
            {
                name: "屬性檢核規則"
            }
        ]

        this.checkStateName = ["開啟SHP", "幾何檢核", "欄位檢核", "屬性檢核", "檔名檢核"];
    }

    componentDidMount() {
        const { readilyAvailableHouseToolContext } = this.context;
        const { LayerAttrsRndContext } = this.context;
        this.readilyAvailableHouseToolContext = readilyAvailableHouseToolContext;
        this.LayerAttrsRndContext = LayerAttrsRndContext;
    }

    componentWillUnmount() {
        if (this.readilyAvailableHouseToolContext.layer) {
            this.readilyAvailableHouseToolContext.layer.resetAllOpacityEntityID();
        }
        window.gMainMap.TerrainView.removeLayer(this.Layer);
    }

    async Async_WaitMapInit() {
        if (window.gMainMap.IsReady) {
            return;
        }
        function Wait(time) {
            return new Promise((rs) => { setTimeout(rs, time ?? 100) })
        }
        while (!window.gMainMap.IsReady) {
            await Wait();
        }
    }

    //選擇檔案
    async handleUpload_OnChange(e) {
        if (e.target.files.length !== 3) {
            window.alertify.log("檔案數量錯誤。");
            this.setState({ fileName: "", uploadDataArray: new Array(3) });
            return;
        }

        //檔案名稱
        let firstFile = e.target.files[0].name.substring(0, e.target.files[0].name.length - 4);
        let secondFile = e.target.files[1].name.substring(0, e.target.files[1].name.length - 4);
        let thirdFile = e.target.files[2].name.substring(0, e.target.files[2].name.length - 4);

        if (firstFile !== secondFile || secondFile !== thirdFile || firstFile !== thirdFile) {
            window.alertify.log("檔名不一致。");
            this.setState({ fileName: "", uploadDataArray: new Array(3) });
            return;
        }

        //副檔名
        let firstFileType = e.target.files[0].name.substring(e.target.files[0].name.length - 4, e.target.files[0].name.length);
        let secondFileType = e.target.files[1].name.substring(e.target.files[1].name.length - 4, e.target.files[1].name.length);
        let thirdFileType = e.target.files[2].name.substring(e.target.files[2].name.length - 4, e.target.files[2].name.length);

        let types = [".shp", ".shx", ".dbf"];
        let typeNum = 0;

        types.forEach(type => {
            if (firstFileType == type || secondFileType == type || thirdFileType == type) {
                typeNum++;
            }
        });

        if (typeNum < 3) {
            window.alertify.log("缺少檔案(.shp、.shx、.dbf)其中之一");
            this.setState({ fileName: "", uploadDataArray: new Array(3) });
            return;
        }

        this.convertFile(e.target.files);
        this.setState({ fileName: firstFile });
    }

    //轉換檔案為uploadData
    convertFile(file) {
        for (let i = 0; i < file.length; i++) {
            let reader = new FileReader();
            reader.readAsDataURL(file[i]);
            reader.onload = () => {
                let res = reader.result.split(',');
                let uploadDataArray = Object.assign({}, this.state.uploadDataArray);
                uploadDataArray[i] = {
                    type: file[i].name.substr(-4, 4),
                    file: res[1]
                };
                this.setState({
                    uploadDataArray: uploadDataArray
                })
            };
        }
    }

    //SHP模型點擊事件
    addModelOnClickEntity(id, pos) {
        const { LayerAttrsRndContext } = this.context;
        this.Layer.getColAndAttrs(id, function (attrs) {
            let 建物層次 = Number(attrs.ATTR[attrs.COL.indexOf("建物層次") + 1]);

            let obj = {};
            for (let i = 1; i < attrs.ATTR.length; i++) {
                let col = attrs.COL[i];
                obj[col] = attrs.ATTR[i];
            }

            LayerAttrsRndContext.update({
                isShowLayerAttrsRnd: true,
                layerAttrsRnd: obj,
                layerAttrsRndTitle: attrs.ATTR[2] + ":" + attrs.ATTR[0],
                layerAttrsRndPosition: { x: pos.x, y: pos.y }
            });
            this.SetFloorColor(建物層次, "#7CF1F3");
        }.bind(this));
    }

    //改變選中樓層顏色
    SetFloorColor(buildingFloor, floorColor) {
        if (this.readilyAvailableHouseToolContext.layer) {
            let id = this.readilyAvailableHouseToolContext.selectedBuildingID;
            this.readilyAvailableHouseToolContext.layer.removeBuildingFloorColor(id);
            this.readilyAvailableHouseToolContext.layer.addBuildingFloorColor(id, buildingFloor, floorColor, 1); //配合建物已經半透明所以這邊給1就好，不然太淡
        }
    }

    //開始檢核
    async startCheck() {
        if (!this.state.loading) {
            let checkStates = [];

            this.setState({ checkStates: checkStates });
            let url = window.gMainMap.MakeDoCmdUrl("CMD_ShpCheckAndUpload");

            if (this.state.fileName != "") {
                this.setState({ loading: true });
                this.checkStateName.forEach(stateName => {
                    checkStates[stateName] = null;
                });
                //上傳檔案與類型
                let firstType = this.state.uploadDataArray[0].type;
                let firstFile = this.state.uploadDataArray[0].file;
                let secondType = this.state.uploadDataArray[1].type;
                let secondFile = this.state.uploadDataArray[1].file;
                let thirdType = this.state.uploadDataArray[2].type;
                let thirdFile = this.state.uploadDataArray[2].file;

                let postdata = {
                    檔案名稱: this.state.fileName,
                    [firstType]: firstFile,
                    [secondType]: secondFile,
                    [thirdType]: thirdFile
                };

                try {
                    const response = await fetch(url, {
                        method: "POST",
                        body: JSON.stringify(postdata)
                    });

                    const json = await response.json();
                    if (json.success) {
                        window.gMainMap.TerrainView.removeLayer(this.Layer);

                        this.checkStateName.forEach(stateName => {
                            checkStates[stateName] = true;
                        });

                        window.gMainMap.TerrainView.addModelSetLayer({
                            url: window.gMainMap.OviewMapServerUrlUnderProxy(),
                            urlTemplate: window.gMainMap.ProxyUrlTemplete(),
                            identifier: json.layerName,
                            callback: function (success, layer) {
                                if (success) {
                                    this.Layer = layer;
                                    layer.setOnClickEntity(this.addModelOnClickEntity.bind(this));
                                }
                                this.setState({ checkStates: checkStates ,loading:false});
                            }.bind(this),
                        });
                    }
                    else {
                        let errorIndex = this.checkStateName.indexOf(json.state);

                        if (json.state == "欄位檢核") {
                            this.setState({ errorCols: json.欄位, errorRows: json.欄位內容, loading: false });
                        }
                        else if (json.state == "屬性檢核") {
                            this.setState({ downloadExcel: json.錯誤報表, loading: false });
                        }

                        this.checkStateName.forEach((stateName, index) => {
                            if (index < errorIndex) {
                                checkStates[stateName] = true;
                            }
                            else if (index == errorIndex) {
                                checkStates[stateName] = false;
                            }
                            else {
                                checkStates[stateName] = undefined;
                            }
                        });

                        this.setState({ checkStates: checkStates, errorMessage: json.message, loading: false });
                    }
                } catch (error) {
                    console.log(error);
                    this.setState({ loading: false });
                }
            }
            else {
                window.alertify.log("請選擇檔案");
            }
        }
    }

    downloadErrorExcel() {
        const link = document.createElement("a");
        link.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + this.state.downloadExcel;
        link.download = "錯誤報表";
        link.click();
        link.remove();
    }

    goto() {
        if (this.Layer) {
            this.Layer.goto();
        }
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow
                header="既有成屋工具"
                content={this.content()}
                width={this.props.width}
                height={this.props.height}
                defaultPosition={this.props.defaultPosition}
                handleMinimize={this.props.handleMinimize}
                handleCancel={this.props.handleCancel}
                isShow={this.props.isShow} />
        );
    }

    /********************************************************/
    /************************UI介面 *************************/

    //狀態圖片
    statusOfImage(status) {
        let src = status === undefined ? "" :
            status === true ? ok :
                status === false ? error : loading;
        return (
            src ? <img src={src} style={{ width: "30px" }} alt='status' /> :
                <div style={{ width: "30px", height: "30px" }} />
        );
    }

    content() {
        return (<>
            <div className='readilyAvailableHouseTool'>
                <div className="readilyAvailableHouseItem-box">
                    {
                        this.list.map(item => {
                            return <ReadilyAvailableHouseItem key={item.name} name={item.name} handleClick={this.handleClick} checkedName={this.state.funcName} />
                        })
                    }
                    {
                        typeof (this.state.checkStates["欄位檢核"]) != "undefined" ? this.state.checkStates["欄位檢核"] === false ?
                            <ReadilyAvailableHouseItem name={"詳細資料"} handleClick={this.handleClick} checkedName={this.state.funcName} /> : null
                            : null
                    }
                </div>
                {
                    this.state.isOpenFunc ? <>
                        {
                            this.state.funcName == "輸入" ? this.inputDataPanel() : null
                        }
                        {
                            this.state.funcName == "屬性檢核規則" ? this.attributeRulePanel() : null
                        }
                        {
                            this.state.funcName == "詳細資料" ? this.detailDataPanel() : null
                        }
                    </>
                        : null
                }
            </div>
        </>
        );
    }

    //輸入資料介面
    inputDataPanel() {
        return (
            <div className="readilyAvailableHouseBox">
                <div className='readilyAvailableHouseBox-row'>
                    檔案:
                    <input type="text"
                        value={this.state.fileName != "" ? this.state.fileName + ".shp," + this.state.fileName + ".shx," + this.state.fileName + ".dpf" : ""}
                        disabled
                        style={{ width: "70%" }} />
                    <label className='readilyAvailableHouseBox-btn'>
                        上傳
                        <input
                            type="file"
                            style={{ width: "1px", height: "1px" }}
                            placeholder="with a placeholder"
                            multiple={true}
                            accept=".dbf, .shp, .shx"
                            onChange={(e) => { e.persist(); this.handleUpload_OnChange(e); }}
                        />
                    </label>
                </div>
                <div className='readilyAvailableHouseBox-row'>
                    <button className='readilyAvailableHouseBox-btn' onClick={() => { this.startCheck(); }}>
                        開始檢核
                    </button>
                </div>
                <div className='readilyAvailableHouseBox-row' style={{ justifyContent: "start" }}>
                    檢核步驟:
                </div>
                <div className='readilyAvailableHouseBox-row' style={{ justifyContent: "start", marginLeft: "80px" }}>
                    <div>
                        {
                            this.checkStateName.map(stateName => {
                                return (
                                    <div className='readilyAvailableHouseBox-row' key={stateName}
                                        style={{ justifyContent: "start", alignItems: "flex-start", padding: "0" }}>
                                        {this.statusOfImage(this.state.checkStates[stateName])}
                                        <span style={{ whiteSpace: "nowrap" }}>{stateName}</span>
                                        {this.state.checkStates[stateName] === false ? <span className="readilyAvailableHouse-Error">
                                            {this.state.errorMessage}</span> : null}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='readilyAvailableHouseBox-row'>
                    {typeof (this.state.checkStates["屬性檢核"]) != "undefined" ? this.state.checkStates["屬性檢核"] === false ?
                        <button className='readilyAvailableHouseBox-btn' style={{ width: "25%" }} onClick={() => { this.downloadErrorExcel(); }}>
                            匯出報表
                        </button> : null : null
                    }
                    {!!this.readilyAvailableHouseToolContext.layer ?
                        <button className='readilyAvailableHouseBox-btn' style={{ width: "25%" }} onClick={() => { this.goto(); }}>
                            定位
                        </button> : null
                    }
                </div>
            </div>
        );
    }

    //顯示規則介面
    attributeRulePanel() {
        return (
            <div className="readilyAvailableHouseBox">
                <div>
                    1.所代碼(必填)，兩位數英文字母之代碼，
                    範例:NG
                </div>
                <div>
                    2.段代碼(必填)，四位數整數，不可有「-」符號，
                    範例:1008
                </div>
                <div>
                    3.建物段名(必填)，
                    範例:香田段
                </div>
                <div>
                    4.建物門牌(必填)，建物門牌欄位過長時({'>'}30個字元)，長度限制254個字元，去看「層次」欄位，判斷規則如下:
                </div>
                <div>
                    (1).J、Y、Z、P (pass)
                </div>
                <div>
                    (2).其他跳提醒
                </div>
                <div>
                    範例:儒林路3號
                </div>
                <div>
                    5.登記日期(必填)，格式：民國年+月+日，
                    範例：1000825
                </div>
                <div>
                    6.登記原因名(選填)，符合「資料統一代碼」表格中規範之代碼，
                    範例:02
                </div>
                <div>
                    7.主要用途名(必填)，判斷規則：
                </div>
                <div>
                    (1).0→早期建物 (pass)
                </div>
                <div>
                    (2).9→未登封 (pass)
                </div>
                <div>
                    (3).A-H、J-M、P、Y、Z(pass)
                </div>
                <div>
                    (4).空白→漏填 (跳錯)
                </div>
                <div>
                    (5).其他跳錯誤
                </div>
                <div>
                    範例:Z
                </div>
                <div>
                    8.主要建材名(選填)，
                </div>
                <div>
                    (1).0~20(PASS)
                </div>
                <div>
                    (2).Y、Z(PASS)
                </div>
                <div>
                    (3).空白(PASS)
                </div>
                <div>
                    (4).其餘跳提醒，
                </div>
                <div>
                    以「鋼筋混凝土加強磚造」為例則填入12。
                </div>
                <div>
                    範例:12
                </div>
                <div>
                    9.總面積(必填)，格式為整數部分最多8位數，小數部分最多2位數

                </div>
                <div>
                    範例: 210.78
                </div>
                <div>
                    10.基地地號(必填)，8位數整數，不可有「-」符號
                    範例:06500000
                </div>
                <div>
                    11.層數(必填)，例如1、2、3，寫001、002、003
                    範例:002
                </div>
                <div>
                    12.層次(必填)
                </div>
                <div>
                    (1).最接近地面層次紀錄(例如1、2、3，寫001、002、003；B01、B02、B03，寫B01)
                </div>
                <div>
                    (2).A01~A29、J、Y、Z、P(跳錯誤)。
                </div>
                <div>
                    (3).僅有數字者，歸類為地上層。
                </div>
                <div>
                    (4).B01為地下一樓，B02為地下二樓，以此類推。
                </div>
                <div>
                    (5).地上層或地下層以程式推算高度，其他放在地面。一層樓3公尺。【圖臺展示規則，非檢核規則】
                </div>
                <div>
                    (6).	夾層以0.5做紀錄。夾層高度為1.5公尺。
                </div>
                <div>
                    範例:002、003.5
                </div>
                <div>
                    13.建物完成日(必填)，格式：民國年+月+日，

                    範例：1000825
                </div>
                <div>
                    14.使用執照號(選填)
                    範例:83彰工管使字154763號
                </div>
                <div>
                    15.xcoord(必填)，TWD97坐標系統(公尺)，EPSG:3826或EPSG:3825，小數部分最多2位數，
                </div>
                <div>
                    範例: 186537.61
                </div>
                <div>
                    16.ycoord(必填)，TWD97坐標系統(公尺)，EPSG:3826或EPSG:3825，小數部分最多2位數，
                </div>
                <div>
                    範例: 2641213.12
                </div>
            </div>
        );
    }

    //詳細資料介面
    detailDataPanel() {
        const colList = this.state.errorCols.map((col, index) =>
            <th key={col} className="readilyAvailableHouse-Table-cell">{col}</th>
        );
        const rowList = this.state.errorRows.map((row, index) => {
            return (
                <tr key={index}>
                    {
                        row.map((rowEle, index) => {
                            let style = "";
                            if (rowEle.includes("╳")) {
                                style = "errorMessage";
                            }
                            return (<td key={rowEle} className={"readilyAvailableHouse-Table-cell " + style}>{rowEle}</td>);
                        })
                    }
                </tr>
            );
        });
        return (
            <div className="readilyAvailableHouseBox" style={{ display: "flex", justifyContent: "center" }}>
                <table className="readilyAvailableHouse-Table">
                    <thead>
                        <tr>
                            {colList}
                        </tr>
                    </thead>
                    <tbody>
                        {rowList}
                    </tbody>
                </table>
            </div>
        );
    }

    handleClick = (name) => {
        let isOpenFunc = this.state.isOpenFunc;
        let funcName = this.state.funcName;
        if (this.state.funcName == name) {
            isOpenFunc = !isOpenFunc;
        }
        else {
            isOpenFunc = true;
        }
        switch (name) {
            case "輸入": {
                funcName = "輸入";
            }
                break;
            case "屬性檢核規則": {
                funcName = "屬性檢核規則";
            }
                break;
            case "詳細資料": {
                funcName = "詳細資料";
            }
                break;
        }

        if (!isOpenFunc) {
            funcName = "";
        }

        this.setState({ isOpenFunc: isOpenFunc, funcName: funcName });
    }

    //縮小視窗 暫用不到
    minimizeWindow = () => {
        this.state
            .draggableWindowContext
            .readilyAvailableHouseTool
            .update({
                isMinimized: true,
            });
    }
}